// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__16fnt","line":"style_line__1-6Hn","fontSize1":"style_fontSize1__3swUc","bold":"style_bold__Mc-JY"};